import { render, staticRenderFns } from "./PaxelRecycleReason.vue?vue&type=template&id=1f84da40&"
import script from "./PaxelRecycleReason.vue?vue&type=script&lang=js&"
export * from "./PaxelRecycleReason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports